module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }